import type { WidgetConfig } from "./types";

/**
 * Starea modulelor, așa cum vine de la API (`GET /modules`).
 *
 * Regula de siguranță: modul necunoscut sau eroare de rețea înseamnă „activ".
 * Un widget nu are voie să-și oprească căutarea pentru că un flag nu s-a putut
 * citi; modulele se folosesc ca să *reduci* funcționalitate, nu ca să rupi
 * magazinul.
 */
export interface ModuleFlags {
  /** true doar dacă răspunsul a venit de la server. */
  loaded: boolean;
  enabled(key: string): boolean;
}

export const ALL_MODULES_ENABLED: ModuleFlags = {
  loaded: false,
  enabled: () => true,
};

const TIMEOUT_MS = 2500;

export async function loadModuleFlags(config: WidgetConfig): Promise<ModuleFlags> {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), TIMEOUT_MS);
  try {
    const response = await fetch(`${config.apiUrl}/modules`, {
      headers: { "x-api-key": config.storeKey },
      signal: controller.signal,
    });
    if (!response.ok) return ALL_MODULES_ENABLED;
    const payload = (await response.json()) as {
      modules?: Record<string, boolean>;
    };
    const modules = payload.modules ?? {};
    return {
      loaded: true,
      enabled: (key: string) => modules[key] !== false,
    };
  } catch {
    return ALL_MODULES_ENABLED;
  } finally {
    window.clearTimeout(timer);
  }
}
